import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import classes from "./Signup.module.css";
import bigcirlce from "../../Assets/bigcircle.svg"
import smallcirlce from "../../Assets/smallcircle.svg"
import promix from "../../Assets/Promix.svg"
import authimg from "../../Assets/authimg.png";
import cal from "../../Assets/calculate.svg"
import accend from "../../Assets/accend.svg"
import corporate from "../../Assets/corporate.svg"
import smallsquare from "../../Assets/smallsquare.svg"
import bigsquare from "../../Assets/bigsquare.svg"
import eye from "../../Assets/eye.svg"
import { Link } from 'react-router';
import eyesoff from "../../Assets/eyesoff.svg"
import { BASE_URL } from "../../Components/API/Api";
import React, { useEffect, useState } from 'react';
import { Spinner } from "react-bootstrap";





const Signin = () => {
    const navigate = useNavigate();
    const [onboardingData, setOnboardingData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [creating, setCreating] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const [ninValidating, setNinValidating] = useState(false);
    const [ninValidationPending, setNinValidationPending] = useState(false);
    const [ninValidationMessage, setNinValidationMessage] = useState('');
    const [ninValidated, setNinValidated] = useState(false);
    const [ninValidationTimeout, setNinValidationTimeout] = useState(null);



    // Cleanup timeout on unmount
    useEffect(() => {
        return () => {
            if (ninValidationTimeout) {
                clearTimeout(ninValidationTimeout);
            }
        };
    }, [ninValidationTimeout]);



    // Step 1: State for form fields
    const [formData, setFormData] = useState({
        nin: "",
        first_name: "",
        last_name: "",
        email: "",
        phone_no: "",
        password: "",
        confirm_password: "",
    });

    // Step 2: Handle input changes
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));

        // Auto-validate NIN when relevant fields change and NIN has 11 digits
        if (['nin', 'first_name', 'last_name'].includes(name)) {
            if (ninValidationTimeout) {
                clearTimeout(ninValidationTimeout);
            }

            const currentFormData = { ...formData, [name]: value };
            const trimmedNin = currentFormData.nin.trim();
            const canValidate =
                trimmedNin.length === 11 &&
                /^\d+$/.test(trimmedNin) &&
                currentFormData.first_name.trim() &&
                currentFormData.last_name.trim();

            if (canValidate) {
                setNinValidationPending(true);
                setNinValidationMessage('');
                setNinValidated(false);

                const timeout = setTimeout(() => {
                    handleNinValidation(currentFormData);
                }, 1500);
                setNinValidationTimeout(timeout);
            } else {
                setNinValidationPending(false);
                setNinValidating(false);
            }
        }
    };

    // Step 3: Handle NIN validation
    const handleNinValidation = async (currentFormData = formData) => {
        const nin = currentFormData.nin.trim();
        const firstName = currentFormData.first_name.trim();
        const lastName = currentFormData.last_name.trim();

        setNinValidationPending(false);
        setNinValidating(true);
        setNinValidationMessage('');

        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${BASE_URL}/v1/onboarding-nin?nin=${encodeURIComponent(nin)}&first_name=${encodeURIComponent(firstName)}&last_name=${encodeURIComponent(lastName)}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Accept": "application/json"
                }
            });

            const result = await response.json();
            console.log("NIN validation response:", result);

            if (response.ok && result?.status === true) {
                // Success - auto-fill form fields
                const ninInfo = result.data?.nin_info || {};
                setFormData(prev => ({
                    ...prev,
                    email: ninInfo.email || '',
                    phone_no: ninInfo.telephoneno || '',
                }));
                setNinValidationMessage('NIN validated successfully');
                setNinValidated(true);
            } else {
                // Handle validation errors - use backend message directly if it's a string
                let errorMessage = 'NIN validation failed';

                if (typeof result?.message === 'string') {
                    errorMessage = result.message;
                } else if (typeof result?.message === 'object') {
                    errorMessage = result?.message?.nin?.[0] || result?.message?.first_name?.[0] || result?.message?.last_name?.[0] || 'NIN validation failed';
                }

                setNinValidationMessage(errorMessage);
                setNinValidated(false);
            }
        } catch (error) {
            console.error("NIN validation error:", error);
            setNinValidationMessage('Failed to validate NIN. Please try again.');
            setNinValidated(false);
        } finally {
            setNinValidating(false);
        }
    };

    const handleCreateAccount = async () => {
        // Clear previous session data to avoid clashes
        localStorage.removeItem("token");
        localStorage.removeItem("authToken");
        localStorage.removeItem("userData");
        localStorage.removeItem("userEmail");
        localStorage.removeItem("userPassword");
        localStorage.removeItem("userNIN");
        localStorage.removeItem("email");

        // Validate NIN before proceeding
        if (!ninValidated) {
            Swal.fire("Validation Required", "Please validate your NIN first", "warning");
            return;
        }

        setCreating(true);
        try {
            const token = localStorage.getItem("token");

            const response = await fetch(`${BASE_URL}/v1/begin_onboarding`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(formData),
            });

            const result = await response.json();
            console.log("Onboarding response:", result);

            // Treat any non-2xx or explicit status === false as an error
            if (!response.ok || result?.status === false) {
                // If backend provided a field-level error for confirm_password, show that specifically
                const confirmError = result?.message?.confirm_password?.[0];
                if (confirmError) {
                    throw new Error(confirmError);
                }

                // Fall back to other field errors (email, phone) or a generic message
                const emailError = result?.message?.email?.[0];
                const phoneError = result?.message?.phone_no?.[0];

                const combinedError = [emailError, phoneError].filter(Boolean).join("\n");

                const fallback = typeof result?.message === "string" ? result.message : combinedError || "Invalid onboarding response";

                throw new Error(fallback);
            }

            // ✅ Save email, password, and NIN in localStorage for auto-login after payment
            localStorage.setItem("userEmail", formData.email);
            localStorage.setItem("userPassword", formData.password);
            localStorage.setItem("userNIN", formData.nin);
            localStorage.setItem("email", formData.email);
            // Always preserve basic signup user data for later session restoration
            const userData = {
                email: formData.email,
                first_name: formData.first_name,
                last_name: formData.last_name,
                phone_no: formData.phone_no,
                nin: formData.nin,
            };
            try {
                localStorage.setItem("userData", JSON.stringify(userData));
            } catch (e) {
                console.error("Failed to persist signup userData", e);
            }

            // ✅ Show backend success message (e.g. "Please check your email...")
            // const successMessage =
            //     (typeof result?.message === "string" && result.message) ||
            //     "Please check your email to verify your account using the OTP provided.";

            // await Swal.fire("Success", successMessage, "success");

            // ✅ Navigate to OTP verification
            // window.location.href = "/onboarding-otp";
            navigate("/onboarding-otp");

        } catch (error) {
            console.error("Error creating onboarding:", error);
            Swal.fire("Error", error.message || "Failed to Create Account", "error");
        } finally {
            setCreating(false);
        }
    };





    return (
        <div>
            <div className={classes.main}>
                <div className={classes.leftside}>

                    <div className={classes.grit}>
                        <img src={promix} className={classes.pro} />
                        <p className={classes.fir_txt}>
                            <span className={classes.fir_txtRest}>Smart </span>
                            <span className={classes.fir_txtAccent}>Accounting</span>
                            <span className={classes.fir_txtRest}> for Nigerian Businesses</span>
                        </p>
                        <p className={classes.sec_txt}>
                            Trusted by SMEs across Nigeria to manage their finances smarter
                        </p>

                        <div>
                            <img src={authimg} className={classes.authimgleft} />
                        </div>
                    </div>
                </div>
                {/* <div className={classes.leftside}>
                    <img src={bigcirlce} className={classes.paint} />
                    <img src={smallcirlce} className={classes.point} />

                    <img src={promix} className={classes.pro} />
                    <p className={classes.fir_txt}>Join 10,000+ Nigerian Businesses</p>
                    <p className={classes.sec_txt}>Start your journey to better financial management with our
                        comprehensive accounting platform</p>

                    <div className={classes.joptd}>
                        <div>
                            <img src={cal} />
                        </div>
                        <div>
                            <p className={classes.cro_pt}>Complete Accounting Suite</p>
                            <p className={classes.mind}>Everything you need to manage your finances</p>
                        </div>
                    </div>
                    <div className={classes.joptd}>
                        <div>
                            <img src={accend} />
                        </div>
                        <div>
                            <p className={classes.cro_pt}>Growth Analytics</p>
                            <p className={classes.mind}>Track your business growth with detailed reports</p>
                        </div>
                    </div>
                    <div className={classes.joptd}>
                        <div>
                            <img src={corporate} />
                        </div>
                        <div>
                            <p className={classes.cro_pt}>Team Collaboration</p>
                            <p className={classes.mind}>Work together with your team seamlessly</p>
                        </div>
                    </div>

                    <div className={classes.mvt}>
                        <button className={classes.pthd}>View Features</button>
                        <button className={classes.simp}>Contact Sales</button>
                    </div>
                    <img src={smallsquare} className={classes.bi_squ} />
                    <img src={bigsquare} className={classes.sm_squ} />
                </div> */}

                <div className={classes.right}>
                    <div className={classes.protw}>
                        <p className={classes.cre_top}>Create Your Account</p>
                        <p className={classes.adkt}>Get started with your free trial today </p>
                    </div>

                    {/* First Name and Last Name - Side by Side */}
                    <div className={classes.portned} style={{ marginBottom: '0px', paddingTop: '0px' }}>
                        <div>
                            <div className={classes.james}>
                                <label className={classes.lab_el}>First Name</label>
                                <input
                                    type='text'
                                    name="first_name"
                                    placeholder='Enter your first name'
                                    className={classes.print}
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    readOnly={ninValidated}
                                    style={{ backgroundColor: ninValidated ? '#f3f4f6' : 'white' }}
                                />
                            </div>
                        </div>
                        <div>
                            <div className={classes.james}>
                                <label className={classes.lab_el}>Last Name</label>
                                <input
                                    type='text'
                                    name="last_name"
                                    placeholder='Enter your last name'
                                    className={classes.print}
                                    value={formData.last_name}
                                    onChange={handleChange}
                                    readOnly={ninValidated}
                                    style={{ backgroundColor: ninValidated ? '#f3f4f6' : 'white' }}
                                />
                            </div>
                        </div>
                    </div>

                  
                    {/* NIN Field - Full Width */}
                    <div style={{ width: '100%' }}>
                        <div className={classes.jamesnin} style={{ width: '100%', marginRight: '20px', paddingTop: '20px' }}>
                            <label className={classes.lab_el}>National Identification Number (NIN)</label>
                            <div className={classes.ninInputWrap}>
                                <input
                                    type='text'
                                    name="nin"
                                    placeholder='Enter your NIN'
                                    className={classes.ninfield}
                                    value={formData.nin}
                                    onChange={handleChange}
                                    disabled={ninValidating}
                                    maxLength={11}
                                    inputMode="numeric"
                                    aria-busy={ninValidationPending || ninValidating}
                                    aria-describedby="nin-validation-status"
                                />
                                {(ninValidationPending || ninValidating) && (
                                    <span className={classes.ninFieldSpinner} aria-hidden="true">
                                        <Spinner animation="border" size="sm" />
                                    </span>
                                )}
                            </div>
                            <div id="nin-validation-status" className={classes.ninValidationStatus} role="status" aria-live="polite">
                                {(ninValidationPending || ninValidating) && (
                                    <p className={classes.ninValidatingText}>
                                        Validating your NIN…
                                    </p>
                                )}
                                {ninValidationMessage && !(ninValidationPending || ninValidating) && (
                                    <p className={ninValidated ? classes.ninSuccessText : classes.ninErrorText}>
                                        {ninValidationMessage}
                                    </p>
                                )}
                            </div>
                        </div>
                    </div>
  {/* BVN and NIN - Side by Side */}
                    {/* <div className={classes.portned} style={{  }}>
                        <div>
                            <div className={classes.jamesnin}>
                                <label className={classes.lab_el}>Biometric Verification Number (BVN)</label>
                                <input
                                    type='text'
                                    name="bvn"
                                    placeholder='Enter your BVN'
                                    className={classes.print}
                                    value={formData.first_name}
                                    onChange={handleChange}
                                    readOnly={ninValidated}
                                    style={{ backgroundColor: ninValidated ? '#f3f4f6' : 'white' }}
                                />
                            </div>
                        </div>
                        <div>
                            <div className={classes.jamesnin}>
                                <label className={classes.lab_el}>National Identification Number (NIN)</label>
                                <input
                                    type='text'
                                name="nin"
                                placeholder='Enter your NIN'
                                className={classes.ninfield}
                                value={formData.nin}
                                onChange={handleChange}
                                disabled={ninValidating}
                                />
                                 {ninValidationMessage && (
                                <p style={{
                                    marginTop: '4px',
                                    fontSize: '12px',
                                    color: ninValidated ? '#10b981' : '#ef4444'
                                }}>
                                    {ninValidationMessage}
                                </p>
                            )}
                            </div>
                        </div>
                    </div> */}





                    <div className={`${classes.portned} ${classes.portnedmble}`}>

                        {/* Other Fields */}
                        <div>
                            <div className={classes.james}>
                                <label className={classes.lab_el} >Email Address</label>
                                <input
                                    type='text'
                                    name="email"
                                    placeholder='Enter your email'
                                    className={classes.print}
                                    value={formData.email}
                                    onChange={handleChange}
                                />

                                <div className={classes.james}>
                                    <label className={classes.lab_el}>Password</label>
                                    <div className={classes.eyeInput}>
                                        <input
                                            type={showPassword ? 'text' : 'password'}
                                            name="password"
                                            placeholder="Create a strong password"
                                            className={classes.prints}
                                            value={formData.password}
                                            onChange={handleChange}
                                        />
                                        <img
                                            src={showPassword ? eyesoff : eye}
                                            alt="Toggle visibility"
                                            className={classes.eye}
                                            onClick={() => setShowPassword((prev) => !prev)}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    </div>
                                </div>
                            </div>


                        </div>


                        <div>
                            <div className={classes.james}>
                                <label className={classes.lab_el}>Phone Number</label>
                                <input
                                    type='text'
                                    name="phone_no"
                                    placeholder='+234 or 08012345678'
                                    className={classes.print}
                                    value={formData.phone_no}
                                    onChange={handleChange}
                                />

                            </div>

                            <div className={classes.james}>
                                <div className={classes.eyeInput}>
                                    <label className={classes.lab_el}>Confirm Password</label>
                                    <input
                                        type={showConfirmPassword ? 'text' : 'password'}
                                        name="confirm_password"
                                        placeholder="Confirm your password"
                                        className={classes.print}
                                        value={formData.confirm_password}
                                        onChange={handleChange}
                                    />
                                    <img
                                        src={showConfirmPassword ? eyesoff : eye}
                                        alt="Toggle visibility"
                                        className={classes.eye2}
                                        onClick={() => setShowConfirmPassword((prev) => !prev)}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className={classes.joshe}>
                        <div className={classes.pintoe}>
                            <input type='checkbox' className={classes.shipet} />
                            <p className={classes.abode}>I agree to the  <span className={classes.crit}>Terms of Service</span> and <span className={classes.crit}>Privacy Policy</span></p>
                        </div>
                    </div>

                    <button className={classes.sign} onClick={handleCreateAccount} disabled={creating}>
                        {creating ? "Creating Account..." : "Create Account"}
                    </button>



                    <p className={classes.rec}>Already have an account?  <Link to="/login"><span className={classes.cptue}>Log in</span></Link></p>
                </div>

            </div>
        </div>
    )
}

export default Signin
